import axios from "../../utils/axios";

// 列表
export function investorList(query) {
    return axios({
        url: "/admin/risk/investor/index",
        method: "get",
        params: query,
    });
}

// 保存
export function investorSaveOrEdit(data, formName, method = "post") {
    var url =
        formName === "add"
            ? "/admin/risk/investor/save"
            : "/admin/risk/investor/edit";
    return axios({
        url: url,
        method: method,
        data: data,
    });
}

// 删除
export function investorDelete(data) {
    return axios({
        url: "/admin/risk/investor/delete",
        method: "post",
        data: data,
    });
}
